<!-- 選擇區塊 -->
<ng-template #Modal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate" *ngIf="info.moType==1">
      <nb-card-header>
        新增公告
      </nb-card-header>
      <nb-card-body>
        
        <div class="row">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">公告內容</label>
            <textarea
              name="Announcement"
              rows="5"
              type="text"
              nbInput
              fullWidth
              [(ngModel)]="announcement"
              maxlength="4000"
            >
            </textarea>
          </div>
        </div>

        <div class="row">
          <ng-container>
            <div class="row mx-0 col-lg-12">
              <label class="label col col-form-label text-nowrap">選擇門市</label>
              <div class="w-100 mt-2">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>門市</th>
                      <th>發佈</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>全選</td>
                      <td>
                        <nb-toggle status="info" [(checked)]="isSelectAll" (change)="toggleSelectAll()">
                        </nb-toggle>
                      </td>
                    </tr>
                    <ng-container *ngFor="let e of mainDataList">
                      <tr>
                        <td>{{ e.content }}</td>
                        <td>
                          <nb-toggle status="info" [(checked)]="e.isChecked" (change)="onStoreToggle()">
                          </nb-toggle>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>

      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSave();">發佈公告</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>

    <nb-card class="staffInfoTemplate" *ngIf="info.moType==2">
      <nb-card-header>
        查看公告
      </nb-card-header>
      <nb-card-body>
        
        <div class="row">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">公告內容</label>
            <textarea
              name="Announcement"
              rows="5"
              type="text"
              nbInput
              fullWidth
              [(ngModel)]="orgData.announcementDetail.Announcement"
              maxlength="4000"
              disabled
            >
            </textarea>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">發佈門市</label>
            <span>{{orgData.announcementDetail.StoreDTOs}}</span>
          </div>
        </div>

      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSave();" *ngIf="info.moType==1">發佈公告</button>
        <button nbButton (click)="ref.close()" *ngIf="info.moType==1">取消</button>
        <button nbButton (click)="ref.close()" *ngIf="info.moType==2">關閉</button>
      </nb-card-footer>
    </nb-card>

  </ng-template>